module.exports = __webpack_public_path__ + "assets/img/left-title-open-496058d0.png";